export default {"src":"/_next/static/media/for-you.8a270746.svg","height":100,"width":145,"blurWidth":0,"blurHeight":0};